<template>
    <div class="bg-white mt-3 p-3 activity-type-create col-12">
        <!-- <b-col cols="12" class=""> -->
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-4">
                <button id="cancel-activity-type-form-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ title }}</span>
            </div>
        </div>
        <b-overlay :show="loading" rounded="sm">
            <b-form class="form-sample" @submit.stop.prevent="createOrUpdate">
                <b-row>
                    <b-col cols="12" md="6">
                        <label class="mb-3"><strong> {{ $nameLabel() }}</strong><span class="red">*</span></label>
                        <b-form-input type="text" class="form-control" id="input-name" v-custom-validation="$textRequired()"
                            v-model="model.name" required :placeholder="$translate('enter_name')" trim @keyup="validateInput()"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 d-flex align-items-center">
                        <div class="form-check me-3">
                            <label class="form-check-label">
                                <input type="checkbox" id="input-is_default" v-model="model.is_default" name="input-is_default"
                                    :value="1" :unchecked-value="0" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                        <label id="is_default-group" for="input-is_default" class="mb-1 ms-2"><strong>
                                {{ $translate('default') }}</strong><span class="red">*</span></label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('description') }} </strong></label>
                        <b-form-textarea type="text" class="form-control" id="input-description" v-model="model.description"
                            :placeholder="$translate('enter_description')" trim></b-form-textarea>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3"><strong>{{ $translate('transaction_type') }} </strong><span
                                class="red">*</span></label>
                        <b-form-select class="form-control" id="input-transaction_type_id"
                            v-custom-validation="$selectRequired()" v-model="model.transaction_type_id" required
                            :disabled="isUpdateMode && (model.last_order_no > 0 )" :options="transactionTypes">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select_transaction_type')
                                }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3"><strong>{{ $translate('officer') }} </strong><span class="red"></span></label>
                        <b-form-select class="form-control" id="input-officer_id" v-custom-validation="$selectRequired()"
                            value-field="id" text-field="name" v-model="model.officer_id" :options="officers">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select_officer')
                                }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3"><strong>{{ $translate('interaction_type') }} </strong><span
                                class="red"></span></label>
                        <b-form-select class="form-control" value-field="id" text-field="name" id="input-interaction_type_id"
                            v-custom-validation="$selectRequired()" v-model="model.interaction_type_id"
                            :options="interactionTypes">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select_interaction_type')
                                }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('customer_portal_name') }}</strong></label>
                        <b-form-input type="text" class="form-control" id="input-customer-portal-name"
                            v-model="model.customer_portal_name"
                            :placeholder="$translate('enter_customer_portal_name')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3"><strong> {{ $translate('review_template') }} </strong></label>
                        <b-form-select class="form-control" id="input-checkoff_template_id" v-model="model.checkoff_template_id"
                            :options="checkoffTemplates">
                            <template #first>
                                <b-form-select-option :value="null"> {{ $translate('select_review_template')
                                }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('reference_prefix') }}</strong></label>
                        <b-form-input type="text" id="input-reference_prefix" class="form-control" v-model="model.reference_prefix"
                            :placeholder="$translate('enter_reference_prefix')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('reference_start_number') }} </strong></label>
                        <b-form-input type="text" id="input-reference_start_number" v-model="model.reference_start_number" class="form-control"
                            :placeholder="$translate('enter_reference_start_number')"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3"><strong>{{ $translate('category') }}</strong></label>
                        <b-form-select class="form-control" id="input-category-3" value-field="id" text-field="name"
                            v-model="model.activity_category_id" :options="categories">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select_category') }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 dd">
                        <label class="mb-3"><strong>{{ $translate('template') }}</strong></label>
                        <b-form-select class="form-control" id="input-template" value-field="id" text-field="name"
                            v-model="model.activity_template_id" :options="filteredTemplates"
                            :disabled="!model.activity_category_id">
                            <template #first>
                                <b-form-select-option :value="null">{{ $translate('select_template') }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="my-3">
                        <label class="mb-3 col-md-11 text-start" id="customer_portal_visible-group"><strong> {{
                            $translate('customer_portal_visibility') }}</strong></label>
                        <div class="d-flex">
                            <div class="form-check me-2 d-flex">
                                <label class="form-check-label">
                                    <input type="checkbox" id="input_customer_portal_visible_viewing"
                                        v-model="model.is_customer_portal_visible" class="col-md-1" />
                                    <i class="input-helper"></i>
                                </label>
                                <label class="col-md-11 text-start" id="customer_portal_visible_viewing-group"
                                    for="input_customer_portal_visible_viewing"><strong>{{ $translate('viewing')
                                    }}</strong></label>
                            </div>
                            <div class="form-check me-2 d-flex">
                                <label class="form-check-label">
                                    <input type="checkbox" id="input_customer_portal_visible_selection"
                                        v-model="model.is_customer_portal_selection" class="col-md-1" />
                                    <i class="input-helper"></i>
                                </label>
                                <label class="col-md-11 text-start" id="customer_portal_visible_selection-group"
                                    for="input_customer_portal_visible_selection"><strong>{{ $translate('selection')
                                    }}</strong></label>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 d-flex align-items-center">
                        <div class="form-check me-3">
                            <label class="form-check-label">
                                <input type="checkbox" id="input-do_release_before_completed" v-model="model.do_release_before_completed" name="input-do_release_before_completed"
                                    :value="1" :unchecked-value="0" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                        <label id="do_release_before_completed-group" for="input-do_release_before_completed" class="mb-1 ms-2">
                            <strong>{{ $translate('do_release_before_completed') }}</strong>
                        </label>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 d-flex align-items-center">
                        <div class="form-check me-3">
                            <label class="form-check-label">
                                <input type="checkbox" id="input-payment_allowed" v-model="model.allow_payment" name="input-payment_allowed"
                                    :value="1" :unchecked-value="0" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                        <label id="payment_allowed-group" for="input-payment_allowed" class="mb-1 ms-2">
                            <strong>{{ $translate('payment_allowed') }}</strong>
                        </label>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 d-flex align-items-center">
                        <div class="form-check me-3">
                            <label class="form-check-label">
                                <input type="checkbox" id="input-rental_allowable" v-model="model.rental_allowable" name="input-rental_allowable"
                                    :value="1" :unchecked-value="0" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                        <label id="rental_allowable-group" for="input-rental_allowable" class="mb-1 ms-2">
                            <strong>{{ $translate('rental_allowed') }}</strong>
                        </label>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3 d-flex align-items-center">
                        <div class="form-check me-3">
                            <label class="form-check-label">
                                <input type="checkbox" id="input-crm_task" v-model="model.crm_task" name="input-crm_task"
                                    :value="1" :unchecked-value="0" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                        <label id="crm_task-group" for="input-crm_task" class="mb-1 ms-2">
                            <strong>{{ $translate('crm_task') }}</strong>
                        </label>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('terms_and_conditions') }} </strong></label>
                        <b-form-textarea type="text" class="form-control" id="input-terms_and_conditions" v-model="model.t_and_c"
                            :placeholder="$translate('enter_terms_and_conditions')" trim></b-form-textarea>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('reminder_before_days') }} </strong></label>
                        <b-form-input type="number" id="input-reminder_before_days" v-model="model.reminder_before_days" class="form-control"
                            :placeholder="$translate('enter_reminder_before_days')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('reminder_after_days') }} </strong></label>
                        <b-form-input type="number" id="input-reminder_after_days" v-model="model.reminder_after_days" class="form-control"
                            :placeholder="$translate('enter_reminder_after_days')"></b-form-input>
                    </b-col>
                   
                    
                   
                </b-row>
              
                <b-row class="border px-1 py-3 mt-3 mx-1 rounded">
                    <b-col cols="12" md="12" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('default_deposit_value') }} </strong></label>
                        
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('default_percent_of_grand_total') }} </strong></label>
                        <b-form-input type="number" id="input-default_percent_of_grand_total" v-model="model.default_percent_of_grand_total" class="form-control"
                            :placeholder="$translate('default_percent_of_grand_total')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('default_percent_of_rental_item_value') }} </strong></label>
                        <b-form-input type="number" id="input-default_percent_of_rental_item_value" v-model="model.default_percent_of_rental_item_value" class="form-control"
                            :placeholder="$translate('default_percent_of_rental_item_value')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3"><strong>{{ $translate('default_flat_amount') }} </strong></label>
                        <b-form-input type="number" id="input-default_flat_amount" v-model="model.default_flat_amount" class="form-control"
                            :placeholder="$translate('default_flat_amount')"></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3" v-if="model.rental_allowable == 1">
                        <label class="mb-3"><strong>{{ $translate('default_rental_days') }} </strong></label>
                        <b-form-input type="number" id="input-default_rental_days" v-model="model.default_rental_days" class="form-control"
                            :placeholder="$translate('default_rental_days')"></b-form-input>
                    </b-col>
                </b-row>
                <MasterDocument v-if="!!model.id" :activity-type-id="model.id"  />
                <b-col md="12" class="mb-2 mt-3 text-center">
                    <b-button id="activity-type-create-btn" v-if="hasPermissionCreate && !model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button id="activity-type-update-btn" v-if="hasPermissionUpdate && model.id" type="submit" class="btn btn-info btn-fw me-2"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button id="activity-type-delete-btn" v-if="model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2"
                        variant="delete-button">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button id="activity-type-cancel-btn" variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button>
                </b-col>

            </b-form>
        </b-overlay>
    </div>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'
import MasterDocument from "./MasterDocument.vue";
export default {
    name: 'activityTypes-ViewItem',
    mixins: [permissionsMixins, popupMixins],
    components:{
        MasterDocument
    },
    data() {
        return {
            componentName: 'Order Type',
            flow_options: [
                { value: '1', text: 'Inbound' },
                { value: '0', text: 'Outbound' },
            ],
            entity_options: [
                { value: '0', text: 'Customer' },
                { value: '1', text: 'Officer' },
            ],
            model: {
                id: 0,
                name: null,
                is_default: false,
                description: null,
                transaction_type_id: null,
                officer_id: null,
                activity_template_id: null,
                activity_category_id: null,
                interaction_type_id: null,
                checkoff_template_id: null,
                is_customer_portal_visible: false,
                is_customer_portal_selection: false,
                do_release_before_completed: false,
                customer_portal_name: null,
                reference_start_number: null,
                reference_prefix: null,
                allow_payment: false,
                rental_allowable: false,
               
            },
            loading: false,
            hasErrors: false,
            disable_transaction_type : true,
        }
    },
    props: ['item'],
    computed: {
        title() { return this.$translate('activity_type') },
        interactionTypes() {
            return this.$store.state.interactionType.interaction_types
        },
        filteredTemplates() {
            console.log('abcbcb', this.templates)
            return this.templates.filter(
                x => x.order_category_id === this.model.activity_category_id
            )
        },
        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        categories() {
            return this.$store.state.orderCategory.categories
        },
        master_document() {
            return this.$store.state.orderType.master_docs.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            return templates
        },
        isUpdateMode() {
            return this.model.id > 0
        },
        checkoffTemplates() {
            return this.$store.state.checkoffTemplates.templates
                .filter(x => x.completed == 1 && x.archived == 0)
                .map(x => ({
                    value: x.id,
                    text: x.name,
                }))
        },
        transactionTypes() {
            return this.$store.state.transactionType.items.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
    },
    watch: {
        'model.activity_category_id': function (val) {
            if(val==null){
                this.$set(this.model, 'activity_template_id', null)
            }
        },
        'model.name': function(val){
            if(val != ""){
                this.model.name =  val.replace(/[^a-zA-Z ]/, '')
                this.model.name =  val.replace(/\s{2,}/g, ' ')
            }
        }
    },
   async mounted() {
        if (this.item.id) {
            this.model = { ...this.item }
            this.model.is_customer_portal_selection = !!this.item.is_customer_portal_selection
            this.model.is_customer_portal_visible = !!this.item.is_customer_portal_visible
            this.model.do_release_before_completed = !!this.item.do_release_before_completed
            //   await  this.fetchOrderFormDetails(this.item.id);
        }
    },
    async created() {
        this.$store.dispatch('orderTemplate/fetchAll')
        this.$store.dispatch('checkoffTemplates/fetchAll',{})
        this.$store.dispatch('transactionType/fetchAll')
        this.$store.dispatch('orderCategory/fetchAll')
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('interactionType/fetchAll')
        await  this.$store.dispatch('orderType/master_docs');
      
       
    },
    methods: {
        validateInput() {
            // Replace any characters that are not letters or space with an empty string
            this.model.name = this.model.name.replace(/[^a-zA-Z\s]/g, '');
            
            // Remove extra spaces
            this.model.name = this.model.name.replace(/\s+/g, ' ');

            // Limit to a single space between words
            this.model.name = this.model.name.replace(/\s\s+/g, ' ');
        },
        cancel() {
            this.$emit('cancel')
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'orderType/delete'
            const action = model.id ? 'update' : 'create'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_activity_type')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = this.$translate('Unable_to_delete_Activity_Type')
            const alertMsg = this.$translate('delete_alert')

            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                action,
                                alertMsg
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
            // this.$emit(
            //     'delete-item',
            //     title,
            //     message,
            //     model.id,
            //     () => {
            //         this.$emit('success', this.$translate('deleted'))
            //     },
            //     path,
            //     errorMsg
            // )
        },

        createOrUpdate() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            
            // allow only letters and single space between words in activity type name
            let pattern = new RegExp(/^\s*([a-zA-Z]+\s)*[a-zA-Z]+\s*$/)
            if(!pattern.test(model.name)){
                this.doToast(this.$translate('error'), this.$translate('invalid_name'), 'danger')
                this.loading = false
                return false
            }
            const path = model.id ? 'orderType/update' : 'orderType/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? this.$translate('updated') : this.$translate('created')
                            this.$emit('success', message)
                        })
                        .catch(error => {
                            console.log("error", error.message)
                            this.doToast(this.$translate('error'), error.message, 'danger')
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        // async fetchOrderFormDetails(order_type_id) {
        //     try {
        //         const response = await this.$store.dispatch('orderType/fetch_order', order_type_id);
        //         console.log('response is------------',response);
        //         this.disable_transaction_type = response;
        //         // this.transactionTypes = response.data.transactionTypes;
        //         // this.isTransactionTypeEditable = response.data.isTransactionTypeEditable;
        //     } catch (error) {
        //         console.error('Error fetching order form details:', error);
        //     }
        // },
    },
}
</script>
